// Angular
import { OnInit, OnDestroy } from '@angular/core';
// Material Dialog
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DevRolePasswordDialogComponent } from '../../../../core/_components/dev-role-switcher/dev-role-password-dialog.component';
// Services
import { DevRoleSwitcherAuthService } from '../../../../core/_services/dev-role-switcher-auth.service';
import { DevImpersonationService } from '../../../../core/_services/dev-impersonation.service';
import { DemoModeService } from '../../../../core/demo-mode';
import { ViewAsScopeService } from '../../../../core/view-as-scope';
// Environment
import { environment } from '../../../../../environments/environment';
// Constants
import { DEV_SWITCHER_REQUIRED_CLICKS, DEV_SWITCHER_CLICK_RESET_TIMEOUT } from '../../../../core/_config/dev.constants';
var TopbarComponent = /** @class */ (function () {
    function TopbarComponent(dialog, _devSwitcherAuthService, roleOverrideService, viewAsScopeService, demoModeService) {
        this.dialog = dialog;
        this._devSwitcherAuthService = _devSwitcherAuthService;
        this.roleOverrideService = roleOverrideService;
        this.viewAsScopeService = viewAsScopeService;
        this.demoModeService = demoModeService;
        this.clickCount = 0;
        this.REQUIRED_CLICKS = DEV_SWITCHER_REQUIRED_CLICKS;
        this.CLICK_RESET_TIMEOUT = DEV_SWITCHER_CLICK_RESET_TIMEOUT;
        // Expose services to template
        this.devSwitcherAuthService = this._devSwitcherAuthService;
    }
    Object.defineProperty(TopbarComponent.prototype, "isSuperAdmin", {
        get: function () {
            return this.roleOverrideService.getOriginalRole() === 'sadmin';
        },
        enumerable: true,
        configurable: true
    });
    TopbarComponent.prototype.ngOnInit = function () {
        // Component initialization
    };
    /**
     * Determine if trigger should be shown
     */
    TopbarComponent.prototype.shouldShowTrigger = function () {
        // Check if authenticated first
        if (this.devSwitcherAuthService.isAuthenticated()) {
            return false;
        }
        // Check if not production
        if (environment.production) {
            return false;
        }
        // Only show trigger for super admins
        // Get original user role (not overridden) to check actual permissions
        var originalRole = this.roleOverrideService.getOriginalRole();
        return originalRole === 'sadmin';
    };
    TopbarComponent.prototype.ngOnDestroy = function () {
        if (this.clickTimeout) {
            clearTimeout(this.clickTimeout);
        }
    };
    /**
     * Handle click on dev switcher trigger
     */
    TopbarComponent.prototype.onDevSwitcherTriggerClick = function () {
        var _this = this;
        // Only track clicks if not production
        if (environment.production) {
            return;
        }
        // If already authenticated, don't track clicks
        if (this.devSwitcherAuthService.isAuthenticated()) {
            return;
        }
        this.clickCount++;
        // Clear existing timeout
        if (this.clickTimeout) {
            clearTimeout(this.clickTimeout);
        }
        // Reset click count after timeout
        this.clickTimeout = setTimeout(function () {
            _this.clickCount = 0;
        }, this.CLICK_RESET_TIMEOUT);
        // If we've reached the required number of clicks, show password dialog
        if (this.clickCount >= this.REQUIRED_CLICKS) {
            this.clickCount = 0;
            if (this.clickTimeout) {
                clearTimeout(this.clickTimeout);
            }
            this.showPasswordDialog();
        }
    };
    /**
     * Show password dialog
     */
    TopbarComponent.prototype.showPasswordDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        dialogConfig.width = '400px';
        dialogConfig.disableClose = true;
        var dialogRef = this.dialog.open(DevRolePasswordDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (result) {
            if (result === true) {
                // Password was correct, store authentication state
                _this.devSwitcherAuthService.setAuthenticated(true);
            }
        });
    };
    return TopbarComponent;
}());
export { TopbarComponent };
